import type { Product } from '#bv/data/products'
import { isSharedAccessListing } from '#bv/lib/sharedAccountListing'

/** One-line body copy for shop / featured cards (avoids repeating title + price). */
export function productCardBlurb(product: Product): string | null {
  if (product.serverBoostConfig) {
    const label = product.serverBoostConfig.durationLabel?.trim()
    return label
      ? `Fixed packages — 2 to 30 boosts (${label}). 14× Best Value unlocks Level 3.`
      : 'Fixed boost packages — 14× Best Value unlocks Discord Level 3.'
  }

  if (product.bundlePicker) {
    const desc = product.bundlePicker.description?.trim()
    if (desc) {
      const sentence = desc.split(/[.!?]/)[0]?.trim()
      if (sentence && sentence.length <= 72) return sentence.endsWith('.') ? sentence : `${sentence}.`
      if (desc.length <= 88) return desc
    }
    const n = product.bundlePicker.tiers.length
    return `${n} plans to choose from — compare tiers before checkout.`
  }

  let text = product.shortDescription.trim()
  const name = product.name.trim()
  if (name) {
    text = text.replace(new RegExp(`^${escapeRegExp(name)}\\s*[—–-]\\s*`, 'i'), '')
  }
  text = text.replace(/\s*—\s*from\s*\$\d+(?:\.\d{2})?\s*/i, '')
  text = text.replace(/\s*—\s*\$\d+(?:\.\d{2})?\s*$/i, '')
  text = text.replace(/\s*·\s*\d+\s+tiers?\s*·.*$/i, '')
  text = text.trim()

  if (!text || /^[\s·—-]+$/.test(text)) return null
  return text
}

export function showSharedAccountCardDisclaimer(product: Product): boolean {
  return isSharedAccessListing(product.name) && !product.bundlePicker
}

/** @deprecated Use showSharedAccountCardDisclaimer */
export const showLifetimeCardDisclaimer = showSharedAccountCardDisclaimer

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
